import React from "react"
import { renderRichText, storyblokEditable } from "gatsby-source-storyblok"
import { Href } from "../utils/helper"

const PopularInterest = ({blok}) => {

  const popularInterestItem = (blok) => (
    <div key={blok._uid} {...storyblokEditable(blok)}
      className="relative mx-auto max-w-md overflow-hidden rounded-lg bg-white shadow hover:brightness-110 hover:scale-105 transition cursor-pointer">
      <a href={Href(blok.ctaUrl)}>
        <div>
          <img className="w-full object-cover" loading="lazy" src={`${blok.bgImage.filename}/m/0x300`} alt={blok.bgImage.alt} />
        </div>
        <div className="absolute inset-0 z-10 bg-gradient-to-t from-black opacity-30"></div>
        <div className="absolute inset-x-0 top-0 z-20 px-12 pt-12 xl:px-6 xl:pt-8 2xl:px-6 2xl:pt-12">
          <h3 className="text-xl 2xl:text-2xl text-white pb-2">{blok.heading}</h3>
          <img className="w-full h-auto" src="/icons/white-dot-line.svg" alt="White dot line"/>
          <p className="text-sm md:text-base text-white" dangerouslySetInnerHTML={{ __html: renderRichText(blok.description) }}></p>
        </div>
      </a>
    </div>
  )
  
  return (
    <section className="py-6" {...storyblokEditable(blok)}>
      <h2 className="flex justify-center font-bold text-3xl md:text-4xl my-6 md:my-10">Popular Interests</h2>
      <div className="container flex flex-col justify-center p-4 mx-auto">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 xl:grid-cols-4">
          <>{blok.popularInterests.map(blok => (popularInterestItem(blok)))}</>          
        </div>
      </div>
    </section>
  )
}
  
export default PopularInterest
